import React from "react";
import PortimaLogoPositivePng from "../../assets/images/png/Portima_Positive-RGB.png";
import { portimaUrl } from "../../utils/urlProvider";

type Props = {
    paddingTop: string;
};

const PortimaLogo = ({ paddingTop }: Props): React.ReactElement => {
    return (
        <a href={portimaUrl}>
            <img
                src={PortimaLogoPositivePng}
                style={{
                    width: "11em",
                    height: "4em",
                    paddingTop,
                }}
                alt="portima logo"
            />
        </a>
    );
};

export default PortimaLogo;
